<div class="fulfillmentLanding oti-wrapper">
  <div class="commandCenterViewKnowledge">
    <div>
      <div class="col-12">
        <div class="messageCenterDetail">
          <div class="row m-0 messageHeader">
            <div class="col-10">
              <h3 class="text-left">
                KNOWLEDGE CENTER
              </h3>
            </div>
            <div class="col-2 viewAll text-right">
              <a (click)="backToHome()" class="text-uppercase">Back To Home</a>
            </div>
            <div class="col-12 m-auto">
              <div class="input-group withButton">
                <input type="text" class="form-control" [(ngModel)]="parentSearchKeyword" placeholder="Topics" aria-describedby="addon">
                <span class="input-group-addon" style="cursor:pointer;" id="addon"><button (click)="searchKnowledge()" [disabled]="parentSearchKeyword?.length < 3">Search</button></span>
              </div>

            </div>
          </div>

          <div *ngIf="knowledgeCenterMessages?.length" class="">
            
            <div class="messageSection col-12 m-auto">
              <ul>
                <li *ngFor="let knowledge of knowledgeCenterMessages; let i = index">{{knowledge.documentTitle}} <span><img [src]="knowledge.iconUrl" (click)="openUrl(knowledge.documentUrl)" class="circle-img" alt="circle-img" /></span></li>
              </ul>

            </div>
          </div>


        </div>
      </div>
    </div>
    <!--<div class="col-12" style="position: fixed; bottom: 5px;">
      <p class="footerNote">If you have any questions or concerns, please reach out to WinField United Customer Service.</p>
    </div>-->
  </div>
</div>
